import instance,{exportExcel} from "./base";
import {  post } from './base';
//充电
const CHARGING_URL =  "https://www.nnjtny.com/charging"
const BICYCLE_CHARGING_URL =  "https://www.nnjtny.com/bicycle_charging"
const OILS_URL = "https://www.nnjtny.com/oils_erp";

const api = {
  // 获取站点数据
  getData_Map() {
      return instance({
        url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getStationList',
        method: 'post',
      })
  },
  // 工业用气
  getData_GYYQ() {
    const  param = {apiCode: 'nnjt_gyyq_ql'}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getStaticStatisticsData',
      method: 'post',
      params: param
    })
  },
  // 获取充电站累计销量
  getAllChargingPower(year) {
    const  param = {year: year}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getChargingPowerTotal',
      method: 'post',
      params: param
    })
  },
  // 获取充电站按年统计销售数据
  getData_XLTJ_Charge_Year(year) {
    const  param = {year: year}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getOrderStatisticsByYear',
      method: 'post',
      params: param
    })
  },
  // 获取充电站按月统计销售数据
  getData_XLTJ_Charge_Month(year,month) {
    const data = {year,month}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getOrderStatisticsByMonth',
      method: 'post',
      params: data
    })
  },
  //获取充电站最近十日的数据
  getData_XLTJ_Charge_Month_Date_Range(param){
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getOrderStatisticsByDateRange',
      method: 'post',
      params: param
    })
  },
  // 获取充电站每日销售明细
  getData_XLTJ_ChargeDayDetail(params) {
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getOrderStatisticsInfo',
      method: 'post',
      params: params
    })
  },
  // 获取加油站按年统计销售数据
  getData_XLTJ_Gasoline_Year(year) {
    const  param = {year: year}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getGasStatisticsByYear',
      method: 'post',
      params: param
    })
  },
  // 获取加油站按月统计销售数据
  getData_XLTJ_Gasoline_Month(param) {
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getGasStatisticsByMonth',
      method: 'post',
      params: param
    })
  },
  //日期区间获取加油站数据
  getDate_XLTJ_GasOnline_DateRange(param){
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getGasStatisticsByDateRange',
      method: 'post',
      params: param
    })
  },
  // 获取加油站按日销售统计详细数据
  getData_XLTJ_GasolineDayDetail(date) {
    const  param = {date: date}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getGasStationStatistics',
      method: 'post',
      params: param
    })
  },
  //获取静态数据数量
  getData_StaticAssetsNum(){
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getStaticAssetsNum',
      method: 'post',
    })
  },
  // 获取加气站按年统计销售数据
  getData_XLTJ_Gas_Year(year) {
    const  param = {apiCode: 'nnjt_gyyq_ql_month_' + year}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getStaticStatisticsData',
      method: 'post',
      params: param
    })
  },
  // 获取取加气站按月统计 销售数据
  getData_XLTJ_Gas_Month(year,month) {
    const  param = {apiCode: 'nnjt_gyyq_ql_month_' + year + '_' + month}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getStaticStatisticsData',
      method: 'post',
      params: param
    })
  },
  getData_XLTJ_Gas_Ten_DaysAgo(){
    const  param = {apiCode: 'nnjt_gyyq_ql_ten_days_ago'}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getStaticStatisticsData',
      method: 'post',
      params: param
    })
  },
  // 获取光伏年统计销售数据
  getData_Photovoltaic(year) {
    const  param = {apiCode: 'nnjt_gf_year_' + year}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getStaticStatisticsData',
      method: 'post',
      params: param
    })
  },
  //获取光伏月销售统计数据
  getData_Photovoltaic_month(year,month) {
    const  param = {apiCode: 'nnjt_gf_month_' + year +'_' + month}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getStaticStatisticsData',
      method: 'post',
      params: param
    })
  },
  getData_Photovoltaic_tenDaysAgo(){
    const  param = {apiCode: 'nnjt_gf_month_tem_days_ago'}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getStaticStatisticsData',
      method: 'post',
      params: param
    })
  },
  // 获取今日数据
  getData_Today() {
    const  param = {apiCode: 'nnjt_jrsj'}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getStaticStatisticsData',
      method: 'post',
      params: param
    })
  },
  getGas_LNG_CNG_Today(){
    const  param = {apiCode: 'nnjt_gas_lng_cng_data'}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getStaticStatisticsData',
      method: 'post',
      params: param
    })
  },
  getGas_BYD_DFD_Today(){
    const  param = {apiCode: 'nnjt_gas_byd_dfd_data'}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getStaticStatisticsData',
      method: 'post',
      params: param
    })
  },
  exportChargingData(param){
    return exportExcel(
        CHARGING_URL + '/pc/platform/statistics/largeScreen/exportChargingStatistics',{...param},
    )
  },
  // 获取今日数据(电)
  getData_Power(date) {
    const  param = {date: date}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getOrderStatisticsByDate',
      method: 'post',
      params: param
    })
  },
  // 获取今日数据(油)
  getData_GasPower(date) {
    const  param = {date: date}
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getDateGasPower',
      method: 'post',
      params: param
    })
  },
  getData_ConverterPower(){
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getConverterPower',
      method: 'post',
    })
  },
  // 获取充电站详情
  getChargeDetail(params) {
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getStationInfo',
      method: 'post',
      params: params
    })
  },
  getSwapStationDetail(params) {
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getSwapStationDetail',
      method: 'post',
      params: params
    })
  },
  getSwapConnectorList(params) {
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getSwapConnectorList',
      method: 'post',
      params: params
    })
  },
  getConverterStatisticsByYear(year) {
    const  param = {"year": year }
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getConverterPowerByYear',
      method: 'post',
      params: param
    })
  },
  getConverterPowerByMonth(year,month) {
    const  param = {"year": year,"month":month }
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getConverterPowerByMonth',
      method: 'post',
      params: param
    })
  },
  getConverterPowerByDateRange(param) {
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getConverterPowerByDateRange',
      method: 'post',
      params: param
    })
  },
  getConverterPowerDetail(param){
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getConverterPowerDetail',
      method: 'post',
      params: param
    })
  },
  //获取充电站监控列表
  getStationCameraList(params){
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getStationCameraList',
      method: 'post',
      params: params
    })
  },
  getGasCameraList(params){
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getGasCameraList',
      method: 'post',
      params: params
    })
  },
  // 获取充电枪列表
  getConnectorList(params) {
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getConnectorList',
      method: 'post',
      params: params
    })
  },
  // 获取充电枪列表
  getPeopleObj(params) {
    return instance({
      url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getPeopleCount',
      method: 'post',
      params: params
    })
  },
  //按年获取二轮车订单统计
  getBicycleChargingOrderStatisticsByYear(year){
     const  param = {year}
    return instance({
      url: BICYCLE_CHARGING_URL + '/pc/largeScreen/getOrderStatisticsByYear',
      method: 'post',
      params: param
    })
  },
  //按月获取二轮车订单统计
  getBicycleChargingOrderStatisticsByMonth(year,month){
    const  param = {year,month}
    return instance({
      url: BICYCLE_CHARGING_URL + '/pc/largeScreen/getOrderStatisticsByMonth',
      method: 'post',
      params: param
    })
  },
  getBicycleChargingOrderStatisticsByDateRange(param){
      return instance({
      url: BICYCLE_CHARGING_URL + '/pc/largeScreen/getOrderStatistics',
      method: 'post',
      params: param
    })
  },
  //获取二轮车今日数据
  getBicycleChargingOrderStatisticsByDate(date){
    const param = {date}
    return instance({
      url: BICYCLE_CHARGING_URL + '/pc/largeScreen/getOrderStatisticsByDate',
      method: 'post',
      params: param
    })
  },
  //根据统计日期获取二轮车订单列表
  getBicycleOrderStatistics(param){
     return instance({
      url: BICYCLE_CHARGING_URL + '/pc/largeScreen/getOrderStatisticsInfo',
      method: 'post',
      params: param
    })
  },

  //获取二轮车站点数量
  getBicycleStationCount(){
    return instance({
      url: BICYCLE_CHARGING_URL + '/pc/largeScreen/countStation',
      method: 'post',
    })
  },
  exportBicycleData(param){
    return exportExcel(
        BICYCLE_CHARGING_URL + '/pc/largeScreen/expertStatistic',{...param},
    )
  },
  getOliStatisticsByYear(param){
    return instance({
      url: OILS_URL + '/pc/largeScreen/getOilStatisticsByYear',
      method: 'post',
      params: param
    })
  },
  getOliStatisticsByMonth(param){
    return instance({
      url: OILS_URL + '/pc/largeScreen/getOilStatisticsByMonth',
      method: 'post',
      params: param
    })
  },
  getOliStatisticsByDay(param){
    return instance({
      url: OILS_URL + '/pc/largeScreen/getOilStatisticsByDay',
      method: 'post',
      params: param
    })
  },
   getOilStatisticsByDate(param){
    return instance({
      url: OILS_URL + '/pc/largeScreen/getOilStatisticsByDate',
      method: 'post',
      params: param
    })
   },
   //按年统计天然气信息
   getNatureGasPowerStatisticsByYear(year){
    const param = {"year": year }
     return post('https://www.edata009.com/charging/pc/natureGasStatistics/getNatureGasPowerStatisticsByYear', param);
   },
   //按月统计天然气信息
   getNatureGasPowerStatisticsByMonth(year,month) {
     const params = {"year": year ,"month" : month}
     return post('https://www.edata009.com/charging/pc/natureGasStatistics/getNatureGasPowerStatisticsByMonth', params);
   },
   //按照时间区间统计天然气信息
   getNatureGasPowerByRange(param) {
     return post('https://www.edata009.com/charging/pc/natureGasStatistics/getNatureGasPowerByRange', param);
   },
   getNatureGasTodayAmount(){
     return post('https://www.edata009.com/charging/pc/natureGasStatistics/getNatureGasTodayAmount', {});
   },
   // 分布式光伏接口
   loadPhotovoltaicStation(){
     return post('https://www.edata009.com/charging/pc/photovoltaic/loadPhotovoltaicStation', {});
   },
   //年
   getStationStatisticsByYear(param){
     return post('https://www.edata009.com/charging/pc/photovoltaic/getStationStatisticsByYear', param);
   },
   //月
   getStationStatisticsByMonth(param){
     return post('https://www.edata009.com/charging/pc/photovoltaic/getStationStatisticsByMonth', param);
   },
   //日期区间
   getByDateRange(param){
     return post('https://www.edata009.com/charging/pc/photovoltaic/getByDateRange', param);
   },
   //当日详情记录
   getDayStatistics(param){
     return post('https://www.edata009.com/charging/pc/photovoltaic/getPhotovoltaicDatStatistics', param);
   },
   loadPhotovoltaicEquipList(param){
    return post('https://www.edata009.com/charging/pc/photovoltaic/getPhotovoltaicEquipmentList', param);
   },
   getDeviceMonitoring(param){
      return post('https://www.edata009.com/charging/pc/photovoltaic/getDeviceMonitoring', param);
   },
   getStreamUrl(param){
      return post('https://www.edata009.com/charging/pc/photovoltaic/getStreamUrl',param);
   }
};

export default api;
